import React, {FC, useEffect} from 'react'

import cn from 'classnames/bind'

import PortableBlocks from 'src/components/blocks/PortableBlocks'
import {Container, Row, Col} from 'src/components/elements/grid'
import {PrivacyPolicyPage} from 'src/types/__sanitySchema__'
import {posthogTrack, klaviyoTrack} from 'src/utils'

import s from './TemplatePrivacyPolicy.module.scss'

const cx = cn.bind(s)

interface ITemplatePrivacyPolicyProps {
	className?: string
	pageContent: PrivacyPolicyPage
}

const TemplatePrivacyPolicy: FC<ITemplatePrivacyPolicyProps> = ({className, pageContent}) => {
	const {title, bodyTitle, body} = pageContent

	useEffect(() => {
		posthogTrack('[PRIVACY POLICY] Page opened')
		klaviyoTrack('Page opened', {page: 'privacy', href: window?.location?.href})
	}, [])

	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col xl={{offset: 1, span: 10}}>
						{title && <h2 className={cx('heading')}>{title}</h2>}
						<div className={cx('typography-page')}>
							{bodyTitle && <div className={cx('page-paragraph-head')}>{bodyTitle}</div>}
							{body && <PortableBlocks blockContent={body} />}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

TemplatePrivacyPolicy.displayName = 'TemplatePrivacyPolicy'

export default TemplatePrivacyPolicy
